<template>
  <Modal v-model="deactivateModal" :title="$t('key1001983')" width="500" :transfer="false" :mask-closable="false"
    @on-visible-change="deactivateChange">
    <Form ref="deactivateForm" :model="deactivateForm" :rules="ruleValidate" :label-width="80" @submit.native.prevent>
      <Row style="width: 90%;">
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1002824')" prop="supplierDisableRemarks">
            <Input
              type="textarea"
              :placeholder="$t('key1002823')"
              :autosize="{ minRows: 4, maxRows: 6}"
              v-model.trim="deactivateForm.supplierDisableRemarks">
            </Input>
          </Form-item>
        </Col>
        <h2 class="font-size-12 ml22" style="color: #D9001B;">{{ $t('key1002825') }}</h2>
      </Row>
    </Form>
    <template #footer>
      <Button @click="deactivateModal = false">{{ $t('key1000112') }}</Button>
      <Button type="error" @click="deactivateBtn">{{ $t('key1002484') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";

export default {
  name: "deactivateModal",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      deactivateModal: false,
      deactivateForm: {
        supplierDisableRemarks: ''
      },
      ruleValidate: {
        supplierDisableRemarks: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002823'), trigger: 'blur'}
        ],
      },
    };
  },
  created() {

  },
  methods: {
    // 确认停用
    deactivateBtn() {
      let v = this;
      v.$refs['deactivateForm'].validate((valid) => {
        if (valid) {
          v.$emit('deactivateBtn', v.deactivateForm.supplierDisableRemarks);
        }
      });
    },
    // 监听弹窗
    deactivateChange(value) {
      if (!value) {
        this.$nextTick(() => {
          this.$refs['deactivateForm'].resetFields();
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>

</style>